export default __webpack_public_path__ + "static/media/MX.a29443f7.ico";